import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonModal, IonSearchbar } from '@ionic/react'
import { locationSharp } from 'ionicons/icons'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useStepsContext } from '../../context/StepsContext'
import useInput from '../../hooks/useInput'
import { COMPLETE_INPUT } from '../../redux/actions'

interface Props {
  label: string
  inputName: string
  options?: any[]
  placeholder?: string
  storeForm: string
  setSelected: (param: string) => {}
  inputsPosition: 'stacked' | 'fixed' | 'floating' | undefined
  disabled?: boolean | undefined
  hidden?: boolean
}

const SelectSearch = ({ label, inputName, options, storeForm, setSelected, disabled, hidden }: Props) => {
  const { setClearSearch, clearSearch }: any = useStepsContext()
  const modal = useRef<HTMLIonModalElement>(null)
  const { input, reduxInput, error, itemRef, handleInput, validity } = useInput(inputName, storeForm)
  const dispatch = useDispatch()
  const [search, setSearch]: any = useState(options)
  const displayData = options?.find((option) => option.value === input || option.value === reduxInput)

  useEffect(() => {
    if (validity) dispatch({ type: COMPLETE_INPUT, payload: { name: inputName, value: input, storeForm } })
    if (setSelected && input) setSelected(input)
    if (inputName === 'geuDescription')
      dispatch({ type: COMPLETE_INPUT, payload: { name: 'accAddressCity', value: '', storeForm } })
  }, [validity, input])

  useEffect(() => {
    if (!search.length) setSearch(options)
  }, [options])

  const searchOption = (event: any) => {
    const currentValue = event.detail.value
    options &&
      setSearch(options.filter((option: any) => option.label.toLowerCase().includes(currentValue.toLowerCase())))
  }

  const handleSelect = (value: string, extraData?: string) => {
    handleInput({ detail: { value } })
    modal.current?.dismiss()
    setSearch(options)
    if (inputName === 'geuDescription') {
      dispatch({ type: COMPLETE_INPUT, payload: { name: 'geuId', value: extraData, storeForm } })
      setClearSearch(!clearSearch)
    }
  }

  return (
    <>
      <IonItem id={`search-${inputName}`} disabled={disabled} shape="round" ref={itemRef}>
        <IonLabel id={inputName}>
          {label}
          <span className="fieldSelected">{displayData?.label}</span>
        </IonLabel>
        <IonModal
          id={`searchSelect-${inputName}`}
          className="procedureMenu"
          ref={modal}
          trigger={inputName}
          initialBreakpoint={0.45}
          breakpoints={[0, 0.3, 0.4, 0.5]}
          mode="ios"
        >
          <IonContent>
            <h4 className="selectSearch-title">{label}</h4>
            <IonSearchbar id="searchBar" onIonChange={searchOption} placeholder="Buscar"></IonSearchbar>
            <IonList>
              {search?.slice(0, 5)?.map(
                (option: any) =>
                  option && (
                    <IonItem key={option.label} onClick={(e) => handleSelect(option.value, option?.id)}>
                      <IonIcon icon={locationSharp} className="locationIcon" />
                      <IonLabel>
                        <h2>{option.label}</h2>
                      </IonLabel>
                    </IonItem>
                  )
              )}
            </IonList>
          </IonContent>
        </IonModal>
      </IonItem>
      <span className="input-error">{error}</span>
    </>
  )
}

export default SelectSearch
